export const mainContentColumnMaxWidth = 700;
export const mainContentColumnMaxWidthForPinnedCollapsibleRightRail = 910;

export interface ContentMainColumnProps {
  /**
   * Optional "role" attribute.
   */
  readonly role?: string;

  /**
   *  Optional column width in pixels.
   */
  readonly width?: number;

  /**
   * Allows the main content column to fill the content area instead of limiting to 700px
   */
  readonly fullWidth?: boolean;
}
